import { combineReducers } from '@reduxjs/toolkit';
import loadingSlice from './slices/loadingSlice';
import loadingWithAnimeSlice from './slices/loadingWithAnimeSlice';
import mobileApplicationSlice from './slices/mobileApplicationSlice';
import flushToasterSlice from './slices/flushToasterSlice';
import authSlice from './slices/admin/authSlice';
import pcSidebarSlice from './slices/admin/pcSidebarSlice';
import logoutButtonSlice from './slices/admin/logoutButtonSlice';
import sidebarSlice from './slices/admin/sidebarSlice';
import userAuthSlice from './slices/user/authSlice';
import userSidebarSlice from './slices/user/sidebarSlice';
import userRecruitmentSearchSlice from './slices/user/recruitmentSearchSlice';
import userJobSearchSlice from './slices/user/jobSearchSlice';
import userJobinfoDetailPrevSlice from './slices/user/jobinfoDetailPrevSlice';
import userRecruitmentDetailPrevSlice from './slices/user/recruitmentDetailPrevSlice';
import companyAuthSlice from './slices/company/authSlice';
import companySidebarSlice from './slices/company/sidebarSlice';
import companyUserSearchSlice from './slices/company/userSearchSlice';
import minionAuthSlice from './slices/minion/authSlice';
import minionSidebarSlice from './slices/minion/sidebarSlice';
const rootReducer = combineReducers({
    // 共通
    //ローディングアイコン
    loading: loadingSlice.reducer,
    loadingWithAnime: loadingWithAnimeSlice.reducer,
    //FLUSHトースター
    flushToaster: flushToasterSlice.reducer,
    // モバイルアプリかどうか
    mobileApplication: mobileApplicationSlice.reducer,
    //職人
    users: userAuthSlice.reducer,
    //職人マイページのサイドバーの表示制御
    userSidebar: userSidebarSlice.reducer,
    //職人画面、仕事詳細からの戻り先URLを保存
    userJobinfoDetailPrev: userJobinfoDetailPrevSlice.reducer,
    //職人画面、求人詳細からの戻り先URLを保存
    userRecruitmentDetailPrev: userRecruitmentDetailPrevSlice.reducer,
    //職人画面、求人検索項目
    userRecruitmentSearch: userRecruitmentSearchSlice.reducer,
    //職人画面、仕事検索項目
    userJobSearch: userJobSearchSlice.reducer,
    //管理者
    admins: authSlice.reducer,
    //管理画面ログアウトの表示制御
    logoutButton: logoutButtonSlice.reducer,
    //管理画面サイドバーの表示制御
    sidebar: sidebarSlice.reducer,
    //管理画面PCのサイドバー表示制御
    pcSidebar: pcSidebarSlice.reducer,
    //事業者
    companies: companyAuthSlice.reducer,
    //事業者マイページのサイドバーの表示制御
    companySidebar: companySidebarSlice.reducer,
    //事業者、ヒーローを探す検索
    companyUserSearch: companyUserSearchSlice.reducer,
    //子方
    minions: minionAuthSlice.reducer,
    //子方マイページのサイドバーの表示制御
    minionSidebar: minionSidebarSlice.reducer,
});
export default rootReducer;
